import { HARDWARE_DOCUMENT_TYPES } from './constants'
import { formatHardwareDocumentFromApi, serializeHardwareDocumentFieldForApi } from './formValues'

export const buildHardwareDocumentApiPayload = (hardwareDocument: Record<string, unknown>) => {
  const payload: Record<string, unknown> = {}
  let hasChanges = false

  for (const field of HARDWARE_DOCUMENT_TYPES) {
    const formValue = formatHardwareDocumentFromApi(hardwareDocument[field])
    const serialized = serializeHardwareDocumentFieldForApi(formValue)
    if (serialized !== undefined) {
      payload[field] = serialized
      hasChanges = true
    }
  }

  return hasChanges ? payload : null
}
